/**
 * Array helper utilities
 */

/**
 * Remove duplicates from an array based on a unique identifier
 * @param {Array} array - The array to filter
 * @param {string} idKey - The property name to use as unique identifier
 * @returns {Array} - Array with duplicates removed
 */
export const removeDuplicates = (array, idKey) => {
    if (!array || array.length === 0) return [];

    const seen = new Set();
    return array.filter(item => {
        const id = item[idKey];
        if (seen.has(id)) {
            return false;
        }
        seen.add(id);
        return true;
    });
};
